import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { baseApiCall } from 'src/api/Api';
import { Title, commonVaribles } from 'src/constants/constVariables';
import { user_management_service } from 'src/constants/url';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { updateRecords } from 'src/redux/features';
import styles from './UserManagementListTable.module.scss';
import globalstyle from 'src/assets/scss/global.module.scss';
import {
	BackButton,
	CustomTab,
	Loader,
	SuccessModal,
	Table,
	WarningModal,
} from 'src/components';
import { UserManagementTableHeader } from './constants';
import { colors } from 'src/assets/scss/partials/colors';
import { hasEditAccess } from 'src/authorization/authorizationsConstants';
import {
	keyOrderforUser,
	userheaderMappings,
} from 'src/constants/constant';
import { downloadData } from 'src/constants/utils';
import { useLocation } from 'react-router-dom';

export const UserManagementListTable = () => {
	const userdata = [];
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user } = useAuthorizationContext();
	const [userList, setUserList] = useState(userdata);
	const [totalData, setTotalData] = useState(0);
	const [checkedState, setCheckedState] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [deleteData, setDeleteData] = useState([]);
	const [isWarningModalOpen, setWarningModalIsOpen] = useState(false);
	const [allSelectedRows, setAllSelectedRows] = useState(false);
	const [checkedStateAll, setCheckedStateAll] = useState(false);
	const [selectCount, setSelectCount] = useState(0);
	const [title, setTitle] = useState({});
	const [isModalOpen, setModalIsOpen] = useState(false);
	const [loader, setLoader] = useState(true);
	const [loaderTbl, setLoaderTbl] = useState(true);
	const SelectedShop = useSelector((state) => state.allshops.shopName?.value);

	useEffect(() => {
		setLoaderTbl(true);
		fetchUserList();
	}, [SelectedShop]);

	useEffect(() => {
		setSelectedRows(new Array(userList.length).fill(false));
		setCheckedState(new Array(userList.length).fill(false));
		dispatch(updateRecords({}));
	}, [userList]);

	useEffect(() => {
		setCheckedState((prev) => prev.map(() => !checkedStateAll));
	}, [checkedStateAll]);

	useEffect(() => {
		setCheckedState((prev) => {
			return [...new Array(userList.length).fill(checkedStateAll)];
		});
	}, [checkedStateAll]);

	useEffect(() => {
		setSelectCount(checkedState.filter((value) => value === true).length);
	}, [checkedState]);

	const toggleWarningModal = (data, e) => {
		setDeleteData(data);
		setWarningModalIsOpen(!isWarningModalOpen);
	};

	const handleCheckbox = () => {
		setCheckedStateAll((prev) => {
			return !prev;
		});
	};

	const handleSingleCheckbox = (position, e) => {
		setCheckedState((prev) => {
			let a = [];
			if (prev.length === 0) {
				userList?.map((item, index) =>
					index === position ? a.push(true) : a.push(false)
				);
			} else {
				prev?.map((item, index) =>
					index === position ? a.push(!item) : a.push(item)
				);
			}
			return [...a];
		});
	};

	const updateSetSelectedRows = async (pos, data, ind) => {
		if (pos === commonVaribles.all) {
			let ab = [];
			setAllSelectedRows(!allSelectedRows);
			ab = userList.map((row, index) => {
				const isSelected = !data.every((row) => row.isSelected);
				if (ind.includes(index) && isSelected) {
					return true;
				} else {
					return false;
				}
			});
			ab
				? setSelectedRows(ab)
				: setSelectedRows([
						...selectedRows,
						...new Array(data.length).fill(false),
					]);
		} else {
			setSelectedRows((prev) => {
				let a = [];
				prev.map((item, index) =>
					index === pos ? a.push(!item) : a.push(item)
				);
				return [...a];
			});
		}
	};

	const createUserRedirect = () => {
		navigate('/user-management/create-user');
	};
	const handleEdit = (data) => {
		const updatedObject = { ...data[0] };
		navigate('/user-management/update-user');
		dispatch(updateRecords(updatedObject));
	};

	const onChangeFilterResetTheCheckbox = () => {
		setSelectedRows(new Array(userList.length).fill(false));
		setCheckedState(new Array(userList.length).fill(false));
	};

	const fetchUserList = () => {
		baseApiCall({
			url: user_management_service.GET_USER_MANAGEMENT_LIST,
			requestBody: {
				shop_id: SelectedShop ? SelectedShop : '',
				sort_by: '',
				reversed: '',
				page_size: '-1',
				offset: '',
			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res?.data?.result && res?.data?.result !== '') {
					setLoader(false);
					setLoaderTbl(false);
					const data = res?.data?.result;
					const modifiedData = data?.map((row) => ({
							...row,
							is_admin_access_modified: row?.is_admin_access ? 'Yes' : 'No'
						})
					);
					
					setUserList(modifiedData);
					setSelectedRows([
						...selectedRows,
						...new Array(modifiedData.length).fill(false),
					]);
				} else {
					setUserList([]);
					setLoader(false);
					setLoaderTbl(false);
				}
			},
			onFailure: (res) => {
				setLoader(false);
				setLoaderTbl(false);
			},
			errorCall: (res) => {
				setLoader(false);
				setLoaderTbl(false);
			},
		});
	};

	const handleMultipleDelete = async (data) => {
		setLoaderTbl(true);
		var deleteData = [];
		var deleteJsonpayload = {};
		data.forEach((element) => {
			deleteData.push(element.id.toString());
		});
		deleteJsonpayload = deleteData;
		baseApiCall({
			url: user_management_service.DELETE_USER,
			requestBody: {
				id: deleteJsonpayload,
			},
			method: commonVaribles.post,

			onSuccess: (res) => {
				fetchUserList();
				setCheckedStateAll(false);
				setCheckedState([]);
				setModalIsOpen(true);
				setTitle(res.data.message);
			},
			onFailure: () => {
				setLoaderTbl(false);
			},
			errorCall: () => {
				setLoaderTbl(false);
			},
		});
	};

	return (
		<>
			{!loader ? (
				<div className={styles.tablecontainer}>
					<div className={globalstyle.breadcrumb}>
						<BackButton
							basePath={Title.home}
							action={Title.user_management}
							handleClick={() => {
								navigate('/');
							}}
							browserBack={true}
						/>
					</div>
					<div>
						<CustomTab
							title={Title.user_management}
							count={totalData}
							isDropdown={true}
						/>
					</div>
          	<div className={styles.tablemain}>
						<Table
							columns={[...UserManagementTableHeader]}
							defaultColumns={[...UserManagementTableHeader]}
							rows={userList}
							rowHeight={38}
							primaryActions={[
								{
									name: commonVaribles.add,
									backgroundColor: colors.light_green,
									actionFn: () => createUserRedirect(),
									shouldEnable: true,
									authOperation: hasEditAccess(
										user,
										commonVaribles.add_user
									),
								},
							]}
							secondaryActions={[
								{
									name: commonVaribles.Delete,
									actionFn: (data, e) => toggleWarningModal(data, e),
									backgroundColor: colors.light_red,
									shouldEnable: true,
									authOperation: hasEditAccess(
										user,
										commonVaribles.delete_user
									),
								},
								{
									name: commonVaribles.Update,
									actionFn: (data) => handleEdit(data),
									backgroundColor: colors.light_green,
									shouldEnable: false,
									authOperation: hasEditAccess(
										user,
										commonVaribles.update_user
									),
								},
								{
									name: commonVaribles.Download,
									actionFn: () => {
										const renamedHeaders = Object.keys(userList[0]).reduce(
											(acc, key) => {
												const newKey = userheaderMappings[key] || key;
												acc[key] = newKey;
												return acc;
											},
											{}
										);
										downloadData(
											selectedRows,
											userList,
											commonVaribles.user_list,
											renamedHeaders,
											keyOrderforUser
										);
									},
									backgroundColor: colors.light_green,
									shouldEnable: true,
									authOperation: commonVaribles.admin,
								},
							]}
							setAsnCount={() => {}}
							downloadBulkSearch={() => {}}
							openUploadFile={() => {}}
							removeRowSelection={false}
							pagination={false}
							infiniteScroll={false}
							setTotalData={setTotalData}
							handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
							selectedRows={selectedRows}
							selectCount={selectCount}
							updateSetSelectedRows={updateSetSelectedRows}
							handleCheckbox={handleCheckbox}
							onChangeFilterResetTheCheckbox={() =>
								onChangeFilterResetTheCheckbox()
							}
							isDataLoading={loaderTbl}
						/>
						{isWarningModalOpen && (
							<WarningModal
								open={isWarningModalOpen}
								handleClose={() => toggleWarningModal()}
								confirmDelete={() => handleMultipleDelete(deleteData)}
							/>
						)}
						{isModalOpen && (
							<SuccessModal
								open={isModalOpen}
								handleClose={() => setModalIsOpen(false)}
								title={title}
							/>
						)}
					</div>
				</div>
			) : (
				<div className={globalstyle.loader}>
					<Loader />
				</div>
			)}
			<style jsx="true">
				{`
					a {
						text-decoration: none;
						color: inherit;
					}
				`}
			</style>
		</>
	);
};
